<div class="container flex-row" *ngIf="isReady">
    <div class="flex-50">
        <mat-form-field class="status-control"
            [ngClass]="{'am-submittals-status': requestor === SubmittalStatusRequestors.AccountManagersLiveList}">
            <mat-label>Submittal Status</mat-label>
            <mat-select [formControl]="selectedSubmittal"
            (selectionChange)="handleOnUpdateSubmittalStatus($event)" data-qa-id="SubmitStatuses">
                <mat-option *ngFor="let status of (statuses | async) | submittalStatusFilter : submittal?.facilityTypeId"
                    [value]="status.id">
                <strong>{{ status.name }}</strong>
                <ng-template #otherStatusOption><span>{{ status.name }}</span></ng-template>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="flex-50" *ngIf="hasReasons">
        <mat-form-field class="reason-control"
            [ngClass]="{'am-submittals-status': requestor === SubmittalStatusRequestors.AccountManagersLiveList}">
        <mat-label>Status Reason</mat-label>
            <mat-select [formControl]="selectedReason"
                (selectionChange)="hanldeUpdateSubmittalStatusReason($event)" data-qa-id="SubmitStatusReasons">
                <mat-option [value]="0">Not Selected</mat-option>
                <mat-option *ngFor="let status of (reasons | async) | submittalStatusReasonFilter : submittal?.submittalStatusId"
                    [value]="status.id">
                <strong *ngIf="selectedReason.value === status.id; else otherReasonOption">{{ status.reason }}</strong>
                <ng-template #otherReasonOption><span>{{ status.reason }}</span></ng-template>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="flex-50" *ngIf="isStartedStatusSelected">
        <mat-form-field class="form-field start-date-control" [ngClass]="{'am-start-date': requestor === SubmittalStatusRequestors.AccountManagersLiveList}">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Start Date" [formControl]="dateStarted" (dateChange)="handleStartDateChange($event)">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
</div>
